module.exports = __webpack_public_path__ + "static/media/img_1.6accd674.png";